<template>
    <div id="content">
        <form autocomplete="off">
            <div class="inner">
                <p class="paging">
                    <router-link
                            :to="{ name: moduleName }"
                            class="btn btn_back"
                            v-translate>Seznam
                    </router-link>
                </p>
                <h1 v-translate>Přidat službu</h1>
            </div>
            <div class="responsiveTabs">
                <div class="tabs_content">
                    <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
                        <div class="left">
                            <h2 v-translate>Výběr operátora</h2>
                        </div>
                        <div class="right">
                            <div class="field_left">
                              <operator-select
                                  v-model="operatorIdComputed"
                                  :options="operatorOptions"
                              >
                              </operator-select>
                            </div>
                            <div class="field_right">
                                <select-box
                                        id="packagebusinessmodel"
                                        :options="businessModelOptions"
                                        v-model="entity.id_business_model"
                                        :disabled="!canEditBusinessModel"
                                        ref="packagebusinessmodelref"
                                    ><translate class="translate">Business model</translate>
                                </select-box>
                            </div>
                        </div>
                    </section>
                    <section>
                        <div class="left">
                            <h2 v-translate>Základní údaje</h2>
                        </div>
                        <div class="right">
                            <div class="field_left">
                                <text-input id="name"
                                            :required="true"
                                            v-model="entity.name"
                                            ref="servicenameref"
                                    ><translate class="translate">Název služby</translate>
                                </text-input>
                                <select-box id="timeshiftenabled"
                                            v-model="timeshift"
                                            :options="nonLinearOptions"
                                            ref="timeshiftenabledref"
                                ><translate class="translate">Timeshift</translate>
                                </select-box>
                                <select-box id="catchupenabled"
                                            v-model="catchup"
                                            :options="nonLinearOptions"
                                            ref="catchupenabledref"
                                ><translate class="translate">Catchup</translate></select-box>
                                <text-input id="catchuphours"
                                            :disabled="!catchup"
                                            v-model="catchupHours"
                                            ref="catchuphoursref"
                                ><translate class="translate">Počet hodin catchupu</translate>
                                </text-input>
                              <text-input id="devicecount"
                                          v-model="entity.device_count"
                                          ref="devicecountsref"
                              >
                                <translate class="translate">Počet současně streamujících zařízení</translate>
                              </text-input>
                              <text-input id="subscriberprofilecount"
                                          v-model="entity.subscriber_profile_count"
                                          ref="subscriberprofilecountsref"
                                          :disabled="disabled"
                              >
                                <translate class="translate">Počet uživatelských profilů</translate>
                              </text-input>
                            </div>
                            <div class="field_right">
                                <select-box
                                        id="weight"
                                        :required="true"
                                        v-model="entity.id_weight_category"
                                        :options="weightCategoriesOptionsByOperator"
                                        ref="serviceweightref"
                                    ><translate class="translate">Váha služby</translate>
                                </select-box>
                                <select-box id="pvrenabled"
                                            v-model="pvr"
                                            :options="nonLinearOptions"
                                            ref="pvrenabledref"
                                ><translate class="translate">PVR</translate></select-box>
                                <text-input id="pvrlifetime"
                                            :disabled="!pvr"
                                            v-model="entity.pvr_lifetime_in_days"
                                            ref="pvrlifetimeref"
                                ><translate class="translate">Počet dní pro uchování nahrávek</translate>
                                </text-input>
                                <text-input
                                        id="pvrfreeminutes"
                                        :disabled="!pvr"
                                        v-model="entity.pvr_free_minutes"
                                        ref="pvrfreeminutesref"
                                    ><translate class="translate">Počet volných minut</translate>
                                </text-input>
                              <checkbox-input
                                  id="deviceaddon"
                                  v-model="entity.device_addon"
                                  ref="deviceaddonref"
                                  class="checkbox"
                              >
                                <translate class="translate">Přičítat počet současně streamujicích zařízení k výsledné službě</translate>
                              </checkbox-input>
                              <checkbox-input
                                  id="subscriberprofileaddon"
                                  v-model="entity.subscriber_profile_addon"
                                  ref="subscriberprofileaddonref"
                                  class="checkbox"
                                  :disabled="disabled"
                              >
                                <translate class="translate">Přičítat počet uživatelských profilů k výsledné službě</translate>
                              </checkbox-input>
                            </div>
                          <div class="field_left">
                            <date-picker id="valid_from"
                                         attrKey="valid_from"
                                         date-format="d. m. yy"
                                         v-model="entity.valid_from"
                                         @update-date="updateEntityDate"
                            >
                              <translate class="translate">Aktivní od</translate>
                            </date-picker>
                          </div>
                          <div class="field_right">
                            <date-picker id="valid_to"
                                         attrKey="valid_to"
                                         date-format="d. m. yy"
                                         v-model="entity.valid_to"
                                         @update-date="updateEntityDate"
                            >
                              <translate class="translate">Aktivní do</translate>
                            </date-picker>
                          </div>
                          <div class="field_left">
                            <date-picker id="assignable_to"
                                         attrKey="assignable_to"
                                         date-format="d. m. yy"
                                         v-model="entity.assignable_to"
                                         @update-date="updateEntityDate"
                            >
                              <translate class="translate">Přiřaditelné do</translate>
                            </date-picker>
                          </div>
                          <div class="field_right">
                            <textarea-input id="note" rows=6 cols=50 v-model="entity.note">
                              <translate class="translate">Poznámka</translate>
                            </textarea-input>
                          </div>
                        </div>
                    </section>
                  <section>
                    <div class="left">
                      <h2 v-translate>Nastavení reklam</h2>
                    </div>
                    <div class="right">
                      <div class="field_left">
                        <select-box id="skippable"
                                    v-model="skippable"
                                    :disabled=entity.autoskip
                                    :options="nonLinearOptions"
                                    ref="skippableref"
                        ><translate class="translate">Povolit přeskakovaní reklam - živě a timeshift</translate>
                        </select-box>
                        <text-input id="skipafterseconds"
                                    v-model="entity.skip_after_seconds"
                                    ref="skipaftersecondsref"
                                    :disabled="!allowSkipAfter"
                        >
                          <translate class="translate">Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením - živě a timeshift</translate>
                        </text-input>
                        <text-input id="timewithnoadvertisementafterstartseconds"
                                    v-model="entity.time_with_no_advertisement_after_start_seconds"
                                    ref="timewithnoadvertisementafterstartsecondsref"
                                    :disabled=entity.autoskip
                        >
                          <translate class="translate">Počet vteřin od začátku přehrávání, po kterém již nelze v reklamě přetáčet - živě a timeshift</translate>
                          </text-input>
                        <checkbox-input
                            id="allowskipmultipleadvertisementblocks"
                            v-model="entity.allow_skip_multiple_advertisement_blocks"
                            ref="allowskipmultipleadvertisementblocksref"
                            :disabled=entity.autoskip
                        >
                          <translate class="translate">Povolit přeskakování více reklamních bloků - živě a timeshift</translate>
                        </checkbox-input>
                        <checkbox-input
                            id="autoskip"
                            v-model="entity.autoskip"
                            ref="autoskipref"
                        >
                          <translate class="translate">Automaticky přeskakovat reklamy</translate>
                        </checkbox-input>
                      </div>
                      <div class="field_right">
                        <select-box id="skippablenonlinear"
                                    v-model="skippableNonlinear"
                                    :disabled=entity.autoskip
                                    :options="nonLinearOptions"
                                    ref="skippablenonlinearref"
                        ><translate class="translate">Povolit přeskakovaní reklam - catchup a pvr</translate>
                        </select-box>
                        <text-input id="skipaftersecondsnonlinear"
                                    v-model="entity.skip_after_seconds_nonlinear"
                                    ref="skipaftersecondsnonlinearref"
                                    :disabled="!allowSkipAfterNonlinear"
                        >
                          <translate class="translate">Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením - catchup a pvr</translate>
                        </text-input>
                        <text-input id="timewithnoadvertisementafterstartsecondsnonlinear"
                                    v-model="entity.time_with_no_advertisement_after_start_seconds_nonlinear"
                                    ref="timewithnoadvertisementafterstartsecondsnonlinearref"
                                    :disabled=entity.autoskip
                        >
                          <translate class="translate">Počet vteřin od začátku přehrávání, po kterém již nelze v reklamě přetáčet - catchup a pvr</translate>
                        </text-input>
                        <checkbox-input
                            id="allowskipmultipleadvertisementblocksnonlinear"
                            v-model="entity.allow_skip_multiple_advertisement_blocks_nonlinear"
                            ref="allowskipmultipleadvertisementblocksnonlinearref"
                            :disabled=entity.autoskip
                        >
                          <translate class="translate">Povolit přeskakování více reklamních bloků - catchup a pvr</translate>
                        </checkbox-input>
                      </div>
                    </div>
                  </section>
                  <section>
                    <div class="left"><h2 v-translate>Pravidelné nahrávky</h2></div>
                    <div class="right">
                      <div class="field_left">
                        <select-box id="periodicpvrenabled"
                                    :disabled="disabled"
                                    v-model="periodic_pvr"
                                    :options="nonLinearOptions"
                                    ref="periodicpvrenabledref"
                        >
                          <translate class="translate">Pravidelné nahrávky</translate>
                        </select-box>
                      </div>
                      <div class="field_right">
                        <text-input id="periodicpvrcount"
                                    v-model="entity.periodic_pvr_count"
                                    :disabled="disabled || !periodic_pvr"
                                    ref="periodicpvrcountref"
                        >
                          <translate class="translate">Maximální počet nahrávek</translate>
                        </text-input>
                      </div>
                      <div class="field_left">
                        <checkbox-input
                            id="periodicpvraddon"
                            v-model="entity.periodic_pvr_addon"
                            ref="periodicpvraddonref"
                            :disabled="disabled || !periodic_pvr"
                            class="checkbox"
                        >
                          <translate class="translate">Přičítat počet nahrávek k výsledné službě</translate>
                        </checkbox-input>
                      </div>
                      <div class="field_right">
                        <text-input id="periodicpvrdaysback"
                                    v-model="entity.periodic_pvr_days_back"
                                    :disabled="disabled || !periodic_pvr"
                                    ref="periodicpvrdaysbackref"
                        >
                          <translate class="translate">Počet dní za CatchUp, kdy lze pouštět nahrávky</translate>
                        </text-input>
                      </div>
                    </div>
                  </section>
                    <detail-bottom-buttons
                            :module-name="moduleName"
                            @submit-form="createEntity"
                    ></detail-bottom-buttons>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
	import detailActions from "@/components/mixins/detail-actions"
	import services from "@/components/views/services/mixins/services"

  export default {
		name: "ServiceNew",
		mixins: [detailActions, services],
		created(ServiceService, ServiceWeightCategoryService, OperatorService, BusinessModelService) {
			this.entityService = ServiceService
			this.serviceWeightCategoryService = ServiceWeightCategoryService
			this.getServiceWeightCategories()

			if (this.$_createActionAllowedAllOrOwnAndGlobal) {
				this.operatorService = OperatorService
				this.businessModelService = BusinessModelService
				this.getOperatorsAndBusinessModelsAndSetIdsToEntity(true, true)
			}
		},
		computed: {
			weightCategoriesOptionsByOperator() {
				let options = []

				if (Number(this.operatorIdComputed) === 0 && this.$_createActionAllowedAllOrOwnAndGlobal) {
					this._.forEach(this.serviceWeightCategories, function (weightCategory) {
						if (weightCategory.global) {
							options.push({
								id: weightCategory['id'],
								text: weightCategory['name'] + ' (' + weightCategory['value'] + ')'
							})
						}
					}.bind(this))
				} else {
					this._.forEach(this.serviceWeightCategories, function (weightCategory) {
						const include = this.$_createActionAllowedAllOrOwnAndGlobal
                            ? Number(weightCategory.id_operator) === Number(this.entity.id_operator)
                            : Number(weightCategory.id_operator) === Number(this.$_loggedUser_operatorId)

						if (weightCategory.global || include) {
							options.push({
								id: weightCategory['id'],
								text: weightCategory['name'] + ' (' + weightCategory['value'] + ')'
							})
						}
					}.bind(this))
                }

				return options
			},
		},
		methods: {
			getServiceWeightCategories() {
				this.setLoadingMessage()
				this.serviceWeightCategoryService.getEntities()
					.then(data => {
						this.serviceWeightCategories = data.service_weight_categories
						this.setServiceWeightCategoryToEntity()
						this.emptyMessage()
					})
					.catch(error => {
						this.setErrorMessage(error['error_message'])
					})
			},
			setServiceWeightCategoryToEntity() {
				if (this.$_createActionAllowedAllOrOwnAndGlobal) {
					this.entity['id_weight_category'] = '1'
				} else if (this.serviceWeightCategories.length > 0) {
					this.entity['id_weight_category'] = this.serviceWeightCategories[0]['id']
				}
			},
			_beforeCreateEntityActions(params) {
				return this.processParamsBeforeCreateAndUpdate(params)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/views/services/ServiceNew.vue